import { Header } from "../components/landing/Header";
import { HeroSection } from "../components/landing/HeroSection";
import { IndustriesSection } from "../components/landing/IndustriesSection";
import { WhyIQHub } from "../components/landing/WhyIQHub";
import { StatsSection } from "../components/landing/StatsSection";
import { JoinExperience } from "../components/landing/JoinExperience";
import { FaqSection } from "../components/landing/FaqSection";
import { NewsletterSection } from "../components/landing/NewsletterSection";
import { Footer } from "../components/landing/Footer";
import { useSeo } from "../hooks/useSeo";

export default function LandingPage() {
  useSeo({
    title: "iQ Hub | Global Executive Conference Organizer",
    description:
      "Founded in 2009, iQ Hub organizes executive conferences across 8 industries in 14 countries, connecting senior decision makers worldwide.",
    ogTitle: "iQ Hub | Global Executive Conference Organizer",
    ogDescription:
      "Founded in 2009, iQ Hub organizes executive conferences across 8 industries in 14 countries, connecting senior decision makers worldwide.",
    ogUrl: "https://www.iq-hub.com/",
    canonical: "https://www.iq-hub.com/",
  });

  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <WhyIQHub />
      <IndustriesSection />
      <StatsSection />
      <JoinExperience />
      <FaqSection />
      <NewsletterSection />
      <Footer />
    </div>
  );
}
